<template>
  <ChecklistItem
    title="6. Advertise your services"
    description="Let everyone know what you offer"
    :is-done="false"
    :editing="false"
  >
    <template #pitch>
      <iText font-size="standard">
        Coming soon...
      </iText>
    </template>
  </ChecklistItem>
</template>

<script>
import ChecklistItem from "@/components/onboarding/ChecklistItem.vue";
export default { name: "AdvertiseChecklist", components: { ChecklistItem } };
</script>

<style scoped lang="scss">
</style>
